import { render } from "./AddReceiver.vue?vue&type=template&id=4ac04e16&scoped=true"
import script from "./AddReceiver.vue?vue&type=script&lang=js"
export * from "./AddReceiver.vue?vue&type=script&lang=js"

import "./AddReceiver.vue?vue&type=style&index=0&id=4ac04e16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac04e16"]])

export default __exports__